// extracted by mini-css-extract-plugin
export default {"block":"Block_block__vfSG0","header":"Block_header__p8Ux8","tag":"Block_tag__W96b+","title":"Block_title__wBtgK","content":"Block_content__iK9YX"};